import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout, tokenReceived } from 'redux/slices/authenticationSlice';
import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {error} from "../redux/slices/statusSlice";

const domain = window.REACT_APP_DOMAIN;
const protocol = window.REACT_APP_PROTOCOL;

const prepareAuthHeaders = (headers, { getState }) =>
{
    // By default, if we have a token in the store, let's use that for authenticated requests
    const token = getState().authentication.token;
    if (token)
    {
        headers.set('Authorization', `Bearer ${token}`)
    }
    return headers;
}

export const baseQuery = fetchBaseQuery({
    baseUrl: protocol + domain,
    credentials: "include",
    prepareHeaders: prepareAuthHeaders
});

let refreshRequest;

export const baseQueryWithReauth = async (args, api, extraOptions) =>
{
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        // try to get a new token
        if(!refreshRequest) {
            refreshRequest = baseQuery('/auth/refresh-token', api, extraOptions);
        }

        const refreshResult = await refreshRequest;

        if (refreshResult.data)
        {
            // store the new token
            api.dispatch(tokenReceived(refreshResult.data.message));

            refreshRequest = undefined;

            // retry the initial query
            result = await baseQuery(args, api, extraOptions);
        }
        else
        {
            refreshRequest = undefined;
            api.dispatch(logout());
            api.dispatch(emptySplitApi.util.resetApiState());

            window.location = "/#/auth/login";
            window.location.reload();

            return result;
        }
    }
    else if (result.error && result.error.status === 500) {
        let count = 0;

        // Let's do a retry for 500 errors for the gateway
        while(count < 5)
        {
            result = await baseQuery(args, api, extraOptions);

            if(result.error)
            {
                count++;
            }
            else
            {
                return result;
            }
        }

        api.dispatch(error(result.error));

        return result;
    }
    else if(result.error)
    {
        api.dispatch(error(result.error));

        return result;
    }

    return result;
}

export const providesTagsList = (type, results) =>
    results ? [
        ...results.map(({id}) => ({type, id})),
        {type, id: 'LIST'},
    ]
    : [{type, id: 'LIST'}]

export const emptySplitApi = createApi({
    baseQuery: baseQueryWithReauth,
    tagTypes: ['UserProfile', 'Company', 'CurrentCompany', 'CompanyUser', 'Department', 'Location', 'Survey',
        'KPI', 'KPITarget', 'KPIValue', 'KPITask', 'PriorityPlanner', 'PriorityOrder', 'PriorityTask', 'SAMTask', 'SAMMeeting'],
    endpoints: () => ({})
})

export const queryStarted = async ({ id, ...patch }, { dispatch, queryFulfilled }, functionName) => {
    const patchResult = dispatch(
        emptySplitApi.util.updateQueryData(functionName, id, (draft) => {
            Object.assign(draft, patch)
        })
    )
    try {
        await queryFulfilled
    } catch {
        patchResult.undo()
    }
}
